<template>
  <div
    class="has-controls-navigations has-controls-navigations--left-above has-controls-navigations--right-above"
    style="overflow:hidden;"
    :class="{'is-inactive ': (!controlsCanScrollToRight && !controlsCanScrollToLeft)}">
    <div
      class="has-controls-navigations-left"
      v-show="controlsCanScrollToLeft"
      :class="{'is-active': controlsCanScrollToLeft, 'is-remove': !controlsCanScrollToLeft}"
      @click="scrollToXControls('left')">
      <span class="icon"><i class="fas fa-chevron-left"></i></span>
      <span class="label"><!--<i>Plus d'informations</i>--></span>
    </div>
    <div
      class="has-controls-navigations-right"
      v-show="controlsCanScrollToRight"
      :class="{'is-active': controlsCanScrollToRight, 'is-remove': !controlsCanScrollToRight}"
      @click="scrollToXControls('right')">
      <span class="icon"><i class="fas fa-chevron-right"></i></span>
      <span class="label"><!--<i>Plus d'informations</i>--></span>
    </div>
    <div
      class="js-wrapper-scroll"
      style="overflow:auto;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// https://benfrain.com/a-horizontal-scrolling-navigation-pattern-for-touch-and-mouse-with-moving-current-indicator/
import VueScrollTo from 'vue-scrollto'
import { debounce } from 'lodash'

export default {
  name: 'ControlHScroll',
  props: {
    reloadControls: [Boolean, Array, Object, Number],
    pas: { type: Number, default: 180, required: false }
  },
  data () {
    return {
      w: window,
      controlsDatas: {
        tableEl: undefined,
        childWidth: 0,
        scrollLeft: false,
        ticking: false,
        wrapperEl: null,
        wrapperWidth: null
      }
    }
  },
  computed: {
    from () {
      return this.$route.name
    },
    controlsCanScrollToLeft () {
      return !(this.controlsDatas.scrollLeft <= 0)
    },
    controlsCanScrollToRight () {
      return (this.controlsDatas.scrollLeft + this.controlsDatas.wrapperWidth) < (this.controlsDatas.childWidth - 1) // - 1 car décalage de un pixel
    }
  },
  watch: {
    reloadControls (v) {
      return this.tickingControls()
    }
  },
  mounted () {
    this.tickingControls()
  },
  destroyed () {
    this.destroyControls()
  },
  methods: {
    initControls () {
      let childEl = this.$el.querySelector('.js-wrapper-scroll div')
      let wrapperEl = this.$el.querySelector('.js-wrapper-scroll') // Element wrapper
      childEl.classList.add('is-clearfix', 'is-pulled-left') // Sinon impossible de calculer la valeur réelle de la largeur
      this.$set(this.controlsDatas, 'wrapperEl', wrapperEl)
      this.$set(this.controlsDatas, 'wrapperWidth', wrapperEl.offsetWidth) // Largeur du wrapper
      this.$set(this.controlsDatas, 'childEl', childEl) // Element enfant
      this.$set(this.controlsDatas, 'childWidth', childEl.offsetWidth) // Largeur de l'enfant

      if (wrapperEl === undefined || this.controlsDatas.childWidth === 0) {
        return false
      }

      this.w.addEventListener('resize', this.tickingControls)

      // Test si on peut scroller horizontalement
      if (this.controlsDatas.childWidth <= this.controlsDatas.wrapperWidth) {
        return false
      } else {
        this.calculsControls()
      }

      this.controlsDatas.wrapperEl.addEventListener('scroll', this.calculsControls)
    },
    tickingControls: debounce(function () {
      if (!this.controlsDatas.ticking) {
        this.w.requestAnimationFrame(() => {
          this.initControls()
          this.$set(this.controlsDatas, 'ticking', false)
        })
        this.$set(this.controlsDatas, 'ticking', true)
      }
    }, 300),
    calculsControls () {
      // $(".content").scrollTo("+=150px", 200, {axis: 'x', limit: false})
      if (!this.controlsDatas.wrapperEl) {
        this.controlsDatas.wrapperEl = this.$el.querySelector('.js-wrapper-scroll')
      }
      let left = this.controlsDatas.wrapperEl.scrollLeft // Le scroll left
      this.$set(this.controlsDatas, 'scrollLeft', left) // Mise à jour de la position du scroll
    },
    destroyControls () {
      if (this.w && this.controlsDatas.wrapperEl) {
        this.w.removeEventListener('resize', this.tickingControls)
        this.$set(this.controlsDatas, 'ticking', false)
        this.controlsDatas.wrapperEl.removeEventListener('scroll', this.calculsControls)
      }
    },
    scrollToXControls (direction = 'right') {
      let offset
      if (direction === 'right') {
        offset = this.controlsDatas.scrollLeft + this.pas
      } else {
        offset = this.controlsDatas.scrollLeft - this.pas
      }
      var options = {
        container: this.controlsDatas.wrapperEl,
        easing: 'ease-in',
        offset: offset,
        force: true,
        cancelable: true,
        onStart: (element) => {
          // scrolling started
        },
        onDone: (element) => {
          // scrolling is done
          this.calculsControls()
        },
        onCancel: () => {
          // scrolling has been interrupted
          this.calculsControls()
        },
        x: true,
        y: false
      }
      VueScrollTo.scrollTo(this.controlsDatas.childEl, 100, options)
    }
  }
}
</script>
